export const exploreResources = [
  {
    name: "Year 1",
    description: "All we need is",
    href: "/teachers-toolkit/year-1-all-we-need-is",
  },
  {
    name: "Year 4",
    description: "Material world",
    href: "/teachers-toolkit/year-4-material-world",
  },
  {
    name: "Year 7",
    description: "Renewable and non-renewable resources",
    href: "/teachers-toolkit/year-7-renewable-and-non-renewable-resources",
  },
  {
    name: "Year 10",
    description: "Law of conservation of energy",
    href: "/teachers-toolkit/year-10-law-of-conservation-of-energy",
  },
  {
    name: "Year 2",
    description: "Water for life",
    href: "/teachers-toolkit/year-2-water-for-life",
  },
  {
    name: "Year 5",
    description: "Light and solar energy",
    href: "/teachers-toolkit/year-5-light-and-solar-energy",
  },
  {
    name: "Year 8",
    description: "Forms of energy",
    href: "/teachers-toolkit/year-8-forms-of-energy",
  },
  {
    name: "Year 10",
    description: "Global systems and climate change",
    href: "/teachers-toolkit/year-10-global-systems-and-climate-change",
  },
  {
    name: "Year 3",
    description: "Heat from the sun",
    href: "/teachers-toolkit/year-3-heat-from-the-sun",
  },
  {
    name: "Year 6",
    description: "Electrical energy and sources",
    href:
      "/teachers-toolkit/year-6-electrical-energy-energy-transformations-and-sources",
  },
  {
    name: "Year 9",
    description: "Energy transfer",
    href: "/teachers-toolkit/year-9-energy-transfer",
  },
  {
    name: "Year 11 & 12",
    description: "Lesson plans",
    href: "/teachers-toolkit/year-11-12-lesson-plans",
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/Explore/TTHTExploreSection.consts.js